import { BookMarked, ExternalLink } from "lucide-react";

export default function SourcesBlock({ sources }) {
  if (!sources?.length) return null;
  return (
    <aside
      className="max-w-2xl mx-auto px-6 md:px-8 pb-10"
      aria-labelledby="sources-heading"
      data-testid="post-sources"
    >
      <div className="border-l-2 pl-5 md:pl-6" style={{ borderColor: "var(--gold)" }}>
        <p id="sources-heading" className="overline mb-3">
          <BookMarked size={12} aria-hidden="true" /> Sources &amp; further reading
        </p>
        <ol className="space-y-2 text-sm text-[#404e48]">
          {sources.map((s, i) => (
            <li key={`${s.url || s.title}-${i}`} className="leading-snug" data-testid={`post-source-${i}`}>
              {s.url ? (
                <a
                  href={s.url}
                  target="_blank"
                  rel="noopener"
                  className="text-[#151e1a] underline decoration-[#e2d9c6] underline-offset-4 hover:decoration-[#1e4a35] hover:text-[#1e4a35] transition-colors inline-flex items-start gap-1"
                >
                  {s.title}
                  <ExternalLink size={11} className="mt-1 shrink-0 opacity-60" aria-hidden="true" />
                </a>
              ) : (
                <span className="text-[#151e1a]">{s.title}</span>
              )}
              {s.publisher && <span className="text-[#66726d]"> — {s.publisher}</span>}
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}
